import React from 'react'
import { ReactComponent as IcoBack } from '../../assets/svg/ico_back_arrow.svg'

const ButtonBack = ({label, onClick}) => {
  return <span onClick={onClick} className="App-back-button">
    <IcoBack style={{width: '20px', height: '20px', paddingRight: '4px' }}/>  {label}
  </span>
}

export default ButtonBack